import {useGetInfiniteStocks} from '@/modules/stocks/batches/api'
import {BatchesHeader} from '@/modules/stocks/batches/components/batches-header'
import {BatchesTable} from '@/modules/stocks/batches/components/batches-table'
import {BatchesSearchSchema} from '@/modules/stocks/batches/schemas'
import {Box} from '@chakra-ui/react'
import {createFileRoute} from '@tanstack/react-router'
import {type OnChangeFn, type SortingState} from '@tanstack/react-table'
import {useCallback} from 'react'

export const Route = createFileRoute('/stocks/batches/')({
  component: BatchesPage,
  validateSearch: BatchesSearchSchema,
})

const LIMIT = 50

function BatchesPage() {
  const search = Route.useSearch()
  const navigate = Route.useNavigate()

  const [sort] = search.sort

  const infiniteStocks = useGetInfiniteStocks({
    limit: LIMIT,
    sort: {
      dir: sort?.desc ? 'desc' : 'asc',
      field: sort?.id || 'createdAt',
    },
    filters: {
      search: search.filters?.search,
      types: search.filters?.types,
      suppliers: search.filters?.suppliers,
      categories: search.filters?.categories,
      subcategories: search.filters?.subcategories,
      stockLocations: search.filters?.stockLocations,
      status: [],
    },
  })

  const {getPageQuery, getSingleQuery, toStartRow, listContextParams} = infiniteStocks

  const onSortingChange = useCallback<OnChangeFn<SortingState>>(
    updaterOrValue => {
      const newValue = typeof updaterOrValue === 'function' ? updaterOrValue(search.sort) : updaterOrValue
      navigate({to: '.', search: prev => ({...prev, sort: newValue})})
    },
    [navigate, search.sort]
  )

  return (
    <>
      <Box flexShrink={0}>
        <BatchesHeader />
      </Box>

      <BatchesTable
        virtualizer={{getPageQuery, getSingleQuery, toStartRow, listContextParams}}
        table={{onSortingChange, state: {sorting: search.sort}}}
      />
    </>
  )
}
